import cn from "classnames"
import { Fragment } from "react"

import { Flex } from "@/atoms"
import { ItemProps } from "."

import styles from "./List.module.scss"

export const Item: React.FC<ItemProps> = ({
  title,
  value,
  suffix,
  wrap,
  classes = {},
  Component = "li"
}) => {
  const Wrapper = wrap ? Flex : Fragment
  const wrapperProps = wrap
    ? { align: "center", gap: 4, className: classes.wrapper }
    : {}

  return (
    <Component className={cn(styles.item, classes.item)}>
      <Wrapper {...wrapperProps}>
        <span className={classes.title}>{title}</span>
        {value && (
          <span className={cn(styles.value, classes.value)}>{value}</span>
        )}
        {suffix && <span>{suffix}</span>}
      </Wrapper>
    </Component>
  )
}
